const BenefitsOnSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31.8" height="29.758">
      <g data-name="グループ 59" fill="none" className="main-stroke" stroke-miterlimit="10" stroke-width="2">
        <g data-name="長方形 186">
          <path stroke="none" d="M0 6.253h31.8v6.728H0z" />
          <path d="M1 7.253h29.8v4.728H1z" />
        </g>
        <g data-name="長方形 187">
          <path stroke="none" d="M1.961 14.378h27.878v15.38H1.961z" />
          <path d="M2.961 15.378h25.878v13.38H2.961z" />
        </g>
        <path data-name="パス 62" d="M10.139 7.115S7.063 3.208 9.704 1.57s6.14.876 6.2 4.683" />
        <path data-name="パス 63" d="M21.661 7.115s3.075-3.907.434-5.545-6.139.876-6.2 4.683" />
      </g>
    </svg>
  )
}

export default BenefitsOnSvg
